const CITIES = [
  { city: "Washington", tz: "America/New_York" },
  { city: "Tel Aviv",   tz: "Asia/Jerusalem" },
  { city: "Tehran",     tz: "Asia/Tehran" },
];

export default function Header({ time, lastFetch, lang, setLang }) {
  return (
    <header className="px-4 pt-3 pb-2.5 border-b border-border-line flex-shrink-0">
      <div className="flex items-center justify-between">
        <div className="text-headline font-bold tracking-tight leading-none">
          Desert Eye
        </div>
        {setLang && (
          <button
            onClick={() => setLang(l => l === "ko" ? "en" : "ko")}
            style={{
              display: "inline-flex", alignItems: "center", gap: 3,
              border: "1px solid rgba(255,255,255,.15)", borderRadius: 9999,
              padding: "3px 9px", background: "transparent", cursor: "pointer",
              fontSize: 10, fontWeight: 700, letterSpacing: ".08em",
            }}
          >
            <span style={{ color: lang === "ko" ? "#ebebeb" : "#888885" }}>KO</span>
            <span style={{ color: "rgba(255,255,255,.2)" }}>|</span>
            <span style={{ color: lang === "en" ? "#ebebeb" : "#888885" }}>EN</span>
          </button>
        )}
      </div>
      <div className="mt-1.5 flex gap-4 items-center flex-wrap tabular">
        {CITIES.map(({ city, tz }) => (
          <span key={tz} className="text-[12px] font-medium text-text-tertiary tracking-[0.01em]">
            {city}{" "}
            <span className="text-text-secondary font-semibold">
              {time.toLocaleTimeString("en-US", { timeZone: tz, hour: "2-digit", minute: "2-digit", hour12: false })}
            </span>
          </span>
        ))}
        {lastFetch && (
          <span className="text-meta font-semibold text-text-tertiary tracking-meta uppercase ml-auto">
            Updated {lastFetch.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: false })}
          </span>
        )}
      </div>
    </header>
  );
}
